module.exports = __webpack_public_path__ + "static/media/1.04733b55.png";